export default __webpack_public_path__ + "static/bge-card-cf1a6b7d7ff5cd60562fc4020b3c1590.jpg";